export enum UserType {
    PlatformAdmin = "Platform_Admin",
    ClientAdmin = "Client_Admin",
}
